module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "rules": _vm.rules,
      "model": _vm.queryForm
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "shop_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "remote-method": _vm.remoteShopMethod,
      "placeholder": "请输入店铺"
    },
    model: {
      value: (_vm.queryForm.shop_id),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "shop_id", $$v)
      },
      expression: "queryForm.shop_id"
    }
  }, _vm._l((_vm.shopList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单号:",
      "prop": "orderId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.queryForm.orderId),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "orderId", $$v)
      },
      expression: "queryForm.orderId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话:",
      "prop": "linkmanTel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.queryForm.linkmanTel),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "linkmanTel", $$v)
      },
      expression: "queryForm.linkmanTel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退款方:",
      "prop": "responsibility"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.responsibility),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "responsibility", $$v)
      },
      expression: "queryForm.responsibility"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "暂无",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "俺来也",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "商家",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "无",
      "value": "4"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "校园ceo",
      "value": "5"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": function($event) {
        return _vm.changeDateType(_vm.dateType)
      }
    },
    model: {
      value: (_vm.dateType),
      callback: function($$v) {
        _vm.dateType = $$v
      },
      expression: "dateType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "申请时间",
      "value": 1
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "退款完成时间",
      "value": 2
    }
  })], 1)], 1), _vm._v(" "), (_vm.dateType == 1) ? _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "startDate"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "type": "date",
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.queryForm.startDate1),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "startDate1", $$v)
      },
      expression: "queryForm.startDate1"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "t-c",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "type": "date",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.queryForm.endDate1),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "endDate1", $$v)
      },
      expression: "queryForm.endDate1"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.dateType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "",
      "prop": "refundStartDate"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "type": "date",
      "value-format": "yyyyMMdd",
      "placeholder": "开始时间"
    },
    model: {
      value: (_vm.queryForm.refundStartDate),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "refundStartDate", $$v)
      },
      expression: "queryForm.refundStartDate"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "t-c",
    attrs: {
      "span": 2
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 11
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "size": "small",
      "type": "date",
      "value-format": "yyyyMMdd",
      "placeholder": "结束时间"
    },
    model: {
      value: (_vm.queryForm.refundEndDate),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "refundEndDate", $$v)
      },
      expression: "queryForm.refundEndDate"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退款结果:",
      "prop": "needRefund"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.needRefund),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "needRefund", $$v)
      },
      expression: "queryForm.needRefund"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "无需退款",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "需要退款",
      "value": "1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "退款原因:",
      "prop": "reasonCode"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.reasonCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "reasonCode", $$v)
      },
      expression: "queryForm.reasonCode"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "配送时间太长",
      "value": "4004"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "点错或不想要了",
      "value": "4006"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "商家缺货或已打烊",
      "value": "4007"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "需要改餐品、时间或地址",
      "value": "4010"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "少做、做错商品",
      "value": "4003"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "撒漏、包装损坏",
      "value": "4001"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "未收到餐",
      "value": "4011"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "商品卫生质量问题",
      "value": "4002"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "配送员提前点击已送达",
      "value": "4008"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "配送员送错订单",
      "value": "4009"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "其他原因",
      "value": "4005"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审批状态:",
      "prop": "approveStatus"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.approveStatus),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "approveStatus", $$v)
      },
      expression: "queryForm.approveStatus"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "商家待审核",
      "value": "990"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "商家逾期未处理",
      "value": "1010"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "商家审核完毕",
      "value": "1005"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "校园经理待审核",
      "value": "1000"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "校园经理审核完毕",
      "value": "2000"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "校园经理逾期未处理",
      "value": "2001"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "城市经理审核完毕",
      "value": "3000"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "已取消",
      "value": "9000"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "是否退款申诉:",
      "prop": "isAppeal"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.queryForm.isAppeal),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "isAppeal", $$v)
      },
      expression: "queryForm.isAppeal"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "是",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "否",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.fetchData(_vm.queryForm.pageNo = 1)
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('queryForm')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "pb20"
  }, [_c('div', [_c('export-excel', {
    attrs: {
      "params": _vm.exportParams,
      "action": _vm.$apiUrl.adminreFundlist,
      "target": 'oc',
      "field": _vm.fieldName,
      "fieldname": _vm.tableTitle,
      "filename": _vm.filename
    }
  })], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "orderId",
      "label": "订单号",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "logTransId",
      "label": "交易号",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "schoolName",
      "label": "学校名称",
      "show-overflow-tooltip": true,
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "supplierShortName",
      "label": "店铺名称",
      "show-overflow-tooltip": true,
      "width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userName",
      "label": "用户名",
      "show-overflow-tooltip": true,
      "width": "110"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "linkmanTel",
      "label": "用户手机",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refundType",
      "label": "退款类型",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.refundType == 1) ? _c('span', [_vm._v("全部商品")]) : _vm._e(), _vm._v(" "), (scope.row.refundType == 2) ? _c('span', [_vm._v("部分商品")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "reason",
      "label": "退款原因",
      "show-overflow-tooltip": true,
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "complaintContent",
      "label": "详细描述",
      "show-overflow-tooltip": true,
      "width": "200"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "approveStatus",
      "label": "审核状态",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.approveStatus == 990) ? _c('span', [_vm._v("商家待审核")]) : _vm._e(), _vm._v(" "), (scope.row.approveStatus == 1010) ? _c('span', [_vm._v("商家逾期未处理")]) : _vm._e(), _vm._v(" "), (scope.row.approveStatus == 1005 || scope.row.approveStatus == 3005) ? _c('span', [_vm._v("商家审核完毕")]) : _vm._e(), _vm._v(" "), (scope.row.approveStatus == 1000) ? _c('span', [_vm._v("校园经理待审核")]) : _vm._e(), _vm._v(" "), (scope.row.approveStatus == 2000) ? _c('span', [_vm._v("校园经理审核完毕")]) : _vm._e(), _vm._v(" "), (scope.row.approveStatus == 2001) ? _c('span', [_vm._v("校园经理逾期未处理")]) : _vm._e(), _vm._v(" "), (scope.row.approveStatus == 3000) ? _c('span', [_vm._v("城市经理审核完")]) : _vm._e(), _vm._v(" "), (scope.row.approveStatus == 9000) ? _c('span', [_vm._v("已取消")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "responsibilityIdentification",
      "label": "退款方",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.responsibilityIdentification == 0) ? _c('span', [_vm._v("暂无")]) : _vm._e(), _vm._v(" "), (scope.row.responsibilityIdentification == 1) ? _c('span', [_vm._v("俺来也")]) : _vm._e(), _vm._v(" "), (scope.row.responsibilityIdentification == 2) ? _c('span', [_vm._v("商家")]) : _vm._e(), _vm._v(" "), (scope.row.responsibilityIdentification == 4) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.responsibilityIdentification == 5) ? _c('span', [_vm._v("校园ceo")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "auditingResult",
      "label": "退款结果",
      "width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.auditingResult == 0) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.auditingResult == 1) ? _c('span', [_vm._v("无需退款")]) : _vm._e(), _vm._v(" "), (scope.row.auditingResult == 2) ? _c('span', [_vm._v("需要退款")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refundAmount",
      "label": "申请金额",
      "show-overflow-tooltip": true,
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "realRefundAmount",
      "label": "退款金额",
      "width": "90"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cutDeliveryFee",
      "label": "配送费扣除",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.cutDeliveryFee ? scope.row.cutDeliveryFee : '—'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "settlePrice",
      "label": "商家结算款扣除",
      "width": "130"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.settlePrice ? scope.row.settlePrice : '—'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "label": "申请退款时间",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.$utils.formatDate(scope.row.createTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "refundDate",
      "label": "退款完成日期",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.$utils.formatDate1(scope.row.refundDate)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderCreateTime",
      "label": "下单时间",
      "width": "160"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.$utils.formatDate(scope.row.orderCreateTime)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "lastAuditingTime",
      "label": "最终审批时间",
      "width": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.$utils.formatDate(scope.row.lastAuditingTime)))])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNo,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.pageSize,
      "prev-text": "上一页",
      "next-text": "下一页",
      "layout": "prev, next"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4047f110"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/aftersale/refund/list.vue
// module id = 866
// module chunks = 0